export default __webpack_public_path__ + "static/media/pantry1-afterG-768w.8c787eaa.webp";